/* eslint-disable react/require-default-props */
import React, { forwardRef, useEffect } from 'react';
import { Popover, PopoverProps } from 'react-bootstrap';
import classNames from 'classnames';

import { PopoverTooltipPlacement } from './PopoverTooltipV2.types';
import { PopoverTooltipVariant } from './PopoverTooltipV2.enum';
import './PopoverTooltipV2.scss';

export interface IPopoverTooltipProps extends PopoverProps {
  title?: string;
  paragraph?: string;
  placement?: PopoverTooltipPlacement;
  variant?: PopoverTooltipVariant;
  className?: string;
  noMinWidth?: boolean;
}

const PopoverTooltip = forwardRef<HTMLDivElement, IPopoverTooltipProps>(
  (
    {
      popper,
      children,
      id,
      title,
      paragraph,
      placement = 'right',
      variant = PopoverTooltipVariant.PRIMARY,
      className,
      noMinWidth,
      ...props
    },
    ref,
  ) => {
    useEffect(() => {
      if (!popper) return;
      popper.scheduleUpdate();
    }, [children, popper]);

    return (
      <Popover
        ref={ref}
        id={id}
        className={classNames('PopoverTooltipV2', className, {
          [`PopoverTooltipV2--${variant}`]: variant,
          [`PopoverTooltipV2--no-min-width`]: noMinWidth,
        })}
        placement={placement}
        {...props}
      >
        {title && <Popover.Title>{title}</Popover.Title>}
        <Popover.Content>{paragraph}</Popover.Content>
      </Popover>
    );
  },
);

export { PopoverTooltip };
